export const getOrderId = (item) => item?.order_id ?? item?.journalentry_id ?? item?.journal_entry_id;
export const getOrderDate = (item) => String(item?.orderedDate ?? item?.journalentry_date ?? "").slice(0, 10);
export const getOrderStatus = (item) => {
  const isTrue = value => value === true || String(value).toLowerCase() === "true";
  if (isTrue(item?.archived)) return "Archived";
  return isTrue(item?.complete) ? "Complete" : "Open";
};
export const formatOrderAmount = (value) => Number(value ?? 0).toLocaleString("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
